import React from 'react';
import PricingListItem from '../../../Domain/PricingListItem';
import ShowEntityData from '../../../Elements/ShowEntityData';
import PricingService from '../../../Services/PricingService';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import PricingEditPanelDescription from './WindowDescription/PricingEditPanelDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import PricingStatusChangeWindowDescription from './WindowDescription/PricingStatusChangeWindowDescription';
import PricingStatusChangeItem from '../../../Domain/PricingStatusChangeItem';
import AuthService from '../../../Services/authService';

export default class PricingItemDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const authService = AuthService.getInstance();

    this.state = {
      id,
      loading: true,
      forceRefresh: 0,
      loggedInUser: authService.GetLoggedInUser(),
    };
  }

  statusCanBeChanged() {
    if (!this.state.selectedItem) {
      return false;
    }

    return (
      this.state.selectedItem.StatusCode < 5 &&
      (this.state.loggedInUser.roles.includes('Admin') ||
        this.state.loggedInUser.roles.includes('OpportunityAdmin') ||
        this.state.loggedInUser.userId === this.state.selectedItem.OpportunityOfficeSalesContact ||
        this.state.loggedInUser.userId === this.state.selectedItem.OfficeSalesContact ||
        this.state.loggedInUser.userId === this.state.selectedItem.AssignedTo ||
        this.state.loggedInUser.userId === this.state.selectedItem.AcctReptId ||
        this.state.loggedInUser.userId === this.state.selectedItem.OpportunityAssignedToId ||
        this.state.loggedInUser.userId === this.state.selectedItem.PrimarySalesRepId)
    );
  }
  renderButtons() {
    return (
      <FigmaButtonRow
        buttons={[
          {
            tooltip: 'Status Change',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            // iconName: 'fa-regular fa-temperature-half',
            iconName: 'fa-solid fa-retweet',
            onClick: () => this.setState({ shownPanel: ShownPanelsEnum.StatusUpdate }),
            disabled: !this.statusCanBeChanged(),
          },
          {
            tooltip: 'Edit',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            iconName: 'fa-regular fa-edit',
            onClick: () => this.setState({ shownPanel: ShownPanelsEnum.EditItem }),
            disabled: !this.state.selectedItem || ![1, 2, 3, 4].includes(this.state.selectedItem.StatusCode),
            roleKey: 'pricing_edit',
          },
          {
            tooltip: 'Refresh',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            iconName: 'fa-regular fa-refresh',
            onClick: () => this.refresh(),
          },
        ]}
      />
    );
  }

  refresh() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      forceRefresh: this.state.forceRefresh + 1,
    });
  }

  onChangeEditedItem(item) {
    if (item.OverrideFee === true) {
      item.RoundFee = false;
    }
  }

  clickOnCancelInPanel() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      forceRefresh: this.state.forceRefresh + 1,
    });
  }

  renderPanels() {
    switch (this.state.shownPanel) {
      case ShownPanelsEnum.EditItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={this.clickOnCancelInPanel.bind(this)}
            clickOnSave={() => this.refresh()}
            windowDescription={PricingEditPanelDescription}
            onChangeEditedItem={(item) => this.onChangeEditedItem(item)}
            editedItem={this.state.selectedItem}
            errorCode={'PID81'}
          />
        );
      case ShownPanelsEnum.StatusUpdate:
        const tempEditedItem = new PricingStatusChangeItem(this.state.selectedItem);
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() => {
              this.setState({
                shownPanel: ShownPanelsEnum.None,
                forceRefresh: this.state.forceRefresh + 1,
              });
            }}
            clickOnSave={() => this.refresh()}
            windowDescription={PricingStatusChangeWindowDescription}
            editedItem={tempEditedItem}
            approveBeforeSaveCheck={PricingStatusChangeWindowDescription.warningCondition}
            approveBeforeSaveMessage={PricingStatusChangeWindowDescription.warningMessage}
            errorCode='PA357'
          />
        );
      default:
        return null;
    }
  }

  render() {
    return (
      <div className='pid-page'>
        {this.renderButtons()}
        <ShowEntityData
          itemId={this.state.id}
          entityName='PricingItem Details'
          userGuideUrl='pricingitemdetails'
          type={PricingListItem}
          serviceGetByIdFunction={PricingService.GetPricingById}
          showRefreshButton={false}
          emptyFieldsEnabled={true}
          itemChanged={(item) => this.setState({ selectedItem: item })}
          forceRefresh={this.state.forceRefresh}
        />
        {this.renderPanels()}
      </div>
    );
  }
}
